export interface QualityProfile {
  name: 'mobile' | 'desktop';
  pixelRatioCap: number;
  spark: {
    maxStdDev: number;
    minPixelRadius: number;
    maxPixelRadius: number;
    minAlpha: number;
    originDistance: number;
    stochastic: boolean;
  };
  cameraPositionThreshold: number;
  cameraRotationThreshold: number;
}

const DESKTOP_QUALITY_PROFILE: QualityProfile = {
  name: 'desktop',
  pixelRatioCap: 2,
  spark: {
    maxStdDev: Math.sqrt(9),
    minPixelRadius: 0,
    maxPixelRadius: 9999,
    minAlpha: 0.005,
    originDistance: 1.0,
    stochastic: false,
  },
  cameraPositionThreshold: 0.0005,
  cameraRotationThreshold: 0.0002,
};

const MOBILE_QUALITY_PROFILE: QualityProfile = {
  name: 'mobile',
  pixelRatioCap: 1,
  spark: {
    maxStdDev: Math.sqrt(3),
    minPixelRadius: 0,
    maxPixelRadius: 160,
    minAlpha: 0.01,
    originDistance: 0.6,
    stochastic: false,
  },
  cameraPositionThreshold: 0.001,
  cameraRotationThreshold: 0.0005,
};

export function detectQualityProfile(): QualityProfile {
  const nav = navigator as Navigator & {
    deviceMemory?: number;
    connection?: {
      effectiveType?: string;
      saveData?: boolean;
    };
  };
  const ua = nav.userAgent ?? '';
  const isTouchDevice = 'ontouchstart' in window || nav.maxTouchPoints > 0;
  const isSmallScreen = window.innerWidth <= 900;
  const lowMemory =
    typeof nav.deviceMemory === 'number' &&
    nav.deviceMemory > 0 &&
    nav.deviceMemory <= 4;
  const connection = nav.connection;
  const saveData = Boolean(connection?.saveData);
  const slowConnection =
    typeof connection?.effectiveType === 'string'
      ? /2g|3g/.test(connection.effectiveType.toLowerCase())
      : false;
  const isMobileUA = /Android|iPhone|iPad|iPod|Windows Phone|Mobi/i.test(ua);
  const isLowPower =
    isMobileUA ||
    (isTouchDevice && isSmallScreen) ||
    lowMemory ||
    saveData ||
    slowConnection;
  return isLowPower ? MOBILE_QUALITY_PROFILE : DESKTOP_QUALITY_PROFILE;
}
